import React from "react";
import { STEPS } from "../mock/mock";

export default function HowItWorks() {
  return (
    <section className="py-24 md:py-32 bg-viimii-2 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="reveal text-center max-w-2xl mx-auto mb-16">
          <p className="section-line text-gold mb-4">How It Works</p>
          <h2 className="font-display text-4xl md:text-5xl font-medium leading-tight">
            Your luxury experience in <span className="gold-gradient-text italic">4 simple steps.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              className="reveal relative p-8 rounded-[28px] border hairline bg-viimii text-center"
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              <div
                className="mx-auto w-16 h-16 rounded-full grid place-items-center font-display text-2xl text-black mb-6"
                style={{ background: "var(--viimii-gold)" }}
              >
                {s.n}
              </div>
              <h3 className="font-display text-xl text-cream mb-3">{s.title}</h3>
              <p className="text-sm text-cream/60 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
